import { render } from "./ReturnCreationRia.vue?vue&type=template&id=bc6849dc&scoped=true"
import script from "./ReturnCreationRia.vue?vue&type=script&lang=js"
export * from "./ReturnCreationRia.vue?vue&type=script&lang=js"

import "./ReturnCreationRia.vue?vue&type=style&index=0&id=bc6849dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6849dc"]])

export default __exports__